import React, { Component, Suspense, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { produce } from 'immer';
import queryString from 'query-string';
import { Card, Form, Row, Col, Button, Dropdown, ButtonGroup, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft, faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { CodingWorksheetService } from '../../services';
import stateHelpers from '../../utilities/stateHelpers';
import WorksheetNavigation from '../../controls/worksheetcontrols/WorksheetNavigation';
import { AssureContext } from '../../components';
import * as WorksheetControls from '../../controls/worksheetcontrols';
import _ from 'lodash';
import { modalActionCreator } from '../../store/actions/modalActions';
import CodingWorksheetPrint from './CodingWorksheetPrint';
import FullPageSpinner, { WorksheetSpinner } from '../../controls/FullPageSpinner';
import ModalRoot from '../../controls/modals/ModalRoot';
//import { spinnerActionCreator } from '../../store/actions';


class CodingWorksheetView extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            codingEventWorksheet: {}, worksheet: { masterSections: [], sections: [] },
            worksheetAnswers: {},
            currentPage: 0,
            pageCount: 0,
            pages: [],
            returnUrl: '',
        };
        this.buildWorksheet = this.buildWorksheet.bind(this);
        this.handleUserInput = this.handleUserInput.bind(this);
        this.changeWorksheetValue = this.changeWorksheetValue.bind(this);
        //this.printWorksheet = this.printWorksheet.bind(this);
        this.getCurrentPage = this.getCurrentPage.bind(this);
        this.validateReviewableQuestion = this.validateReviewableQuestion.bind(this);
        this.changePage = this.changePage.bind(this);
        this.goToPage = this.goToPage.bind(this);
        this.saveWorksheet = this.saveWorksheet.bind(this);
        this.saveAndCloseWorksheet = this.saveAndCloseWorksheet.bind(this);
        //this.closeWorksheet = this.closeWorksheet.bind(this);
        //this.changeStatus = this.changeStatus.bind(this);
        this.getNavigation = this.getNavigation.bind(this);
        this.scrollToSection = this.scrollToSection.bind(this);
    }

    async componentDidMount() {
        await this.getWorksheet();
    }

    async buildPages() {
        const ws = this.state.worksheet;
        const len = this.state.worksheet.masterSections.length;
        const sections = [...this.state.worksheet.masterSections];
        let pageCount = Math.ceil(len / 10);
        pageCount = pageCount === 0 ? 1 : pageCount;
        let currentPage = this.state.currentPage??0;
        let pages = [];
        var i;
        for (i = 0; i < pageCount; i++) {
            pages.push(sections.splice(0, 10));
        }
        this.setState({ pages: pages, currentPage: currentPage, pageCount: pageCount });
    }

    getCurrentPage() {
        if (this.state.pages[this.state.currentPage] !== undefined) {
            return this.state.pages[this.state.currentPage].map((section, idx) => this.buildSection(section, idx));
        }
        return null;
    }

    async saveAndCloseWorksheet() {
        //var result = await this.saveWorksheet();
        //// nav back
        //if (result) {
        //    this.closeWorksheet();
        //}
    }

    //closeWorksheet() {
    //    this.props.history.push('/coding/event/' + this.state.codingEventWorksheet.codingEventId);
    //}

    //changeStatus(statusId) {
    //    //let partialState = { ...this.state.codingEventWorksheet };
    //    //partialState.status = statusId;
    //    //this.setState({ codingEventWorksheet: partialState }, async () => await this.saveWorksheet())
    //}

    async saveWorksheet() {
        //var eventService = new CodingWorksheetService();
        //var eventId = this.state.codingEventWorksheet.id;
        //const codingEventWorksheet = this.state.codingEventWorksheet;
        //codingEventWorksheet.worksheet = this.state.worksheet;
        //codingEventWorksheet.worksheetAnswers = this.state.worksheetAnswers;
        //var callResult = await eventService.saveWorksheet(eventId, codingEventWorksheet);
        //if (callResult.result) {
        //    let model = callResult.model;
        //    this.setState({
        //        codingEventWorksheet: model,
        //        worksheetAnswers: model.worksheetAnswers
        //    });
        //    return true;
        //}
    }

    async getWorksheet() {
        if (this.props.match.params.id !== undefined) {
            var eventService = new CodingWorksheetService();
            var masterWorksheetId = this.props.match.params.id;
            var callResult = await eventService.viewWorksheet(parseInt(masterWorksheetId));

            if (callResult.result) {
                let vm = callResult.model;
                this.setState({
                    codingEventWorksheet: vm,
                    worksheet: vm.worksheet,
                    worksheetAnswers: vm.worksheetAnswers
                }, () => this.buildPages());
            }
        }
    }

    buildWorksheet() {
        if (this.state.pages.length > 0) {

            var page = this.state.pages[this.state.currentPage];
            var sections = page.map((section, idx) => this.buildSection(section, idx));

            return sections;
        }
        return null;
    }

    buildSection(section, idx) {
        var partialState = this.state.worksheetAnswers;
        if (partialState[section.controlGroup] === undefined || partialState[section.controlGroup] === null) {
            partialState[section.controlGroup] = { Rationale: '' };

            this.setState({ worksheetAnswers: partialState });
        }
        if (section.reviewable) {
            return (
                <div style={{ width: "100%" }} id={"section-" + idx}>
                    <div className="title-header">{section.controlGroup}: {section.name}</div>
                    <Form.Row>
                        <Col>
                            <Form.Label><b>Initial</b></Form.Label> <br />
                            {section.masterQuestions.map(
                                (question) => this.buildQuestion(question, section.controlGroup, 'Initial'))}
                        </Col>
                        <Col>
                            <Form.Label><b>Revised</b></Form.Label><br />
                            {section.masterQuestions.map(
                                (question) => this.buildQuestion(question, section.controlGroup, 'Revised'))}
                        </Col>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} lg="12">
                            <WorksheetControls.WorksheetTextarea
                                label="Rationale"
                                as="textarea" rows="2"
                                colLg="12"
                                name={section.controlGroup + ':Rationale'}
                                value={this.state.worksheetAnswers[section.controlGroup]['Rationale']}
                                onChangeInput={this.handleUserInput} />
                        </Form.Group>
                    </Form.Row>
                </div>
            );
        } else {
            return (
                <div style={{ width: "100%" }} id={"section-" + idx}>
                    <div className="title-header">{section.name}</div>
                    <Form.Row>
                        {section.masterQuestions.map((question) => this.buildQuestion(question, section.controlGroup, null))}
                    </Form.Row>
                </div>
            );
        }

    }

    buildQuestion(question, parentControlGroup, controlFieldName) {
        try {
            let Control = WorksheetControls[question.controlType];
            let parentName = parentControlGroup + ':' + question.controlGroup;
            if (controlFieldName !== null) {
                var partialState = this.state.worksheetAnswers;
                if (partialState[parentControlGroup][question.controlGroup] === undefined ||
                    partialState[parentControlGroup][question.controlGroup] === null) {
                    partialState[parentControlGroup][question.controlGroup] = {}
                    this.setState({ worksheetAnswers: partialState });
                }
                let controlName = parentName + ':' + controlFieldName;
                return (
                    <Control
                        onChangeInput={this.handleUserInput}
                        parentControlGroup={parentControlGroup}
                        onBlur={() => this.validateReviewableQuestion(parentName)}
                        name={controlName}
                        error={this.state.worksheetAnswers[parentControlGroup][question.controlGroup]["error"]}
                        value={this.state.worksheetAnswers[parentControlGroup][question.controlGroup][controlFieldName]} {...question} />
                );
            } else {
                const colLg = question.controlType === 'WorksheetTextarea' ? 12 : 4;
                const colMd = question.controlType === 'WorksheetTextarea' ? 12 : 6;
                return (
                    <Control
                        onChangeInput={this.handleUserInput}
                        name={parentName}
                        colLg={colLg}
                        colMd={colMd}
                        parentControlGroup={parentControlGroup}
                        value={this.state.worksheetAnswers[parentControlGroup][question.controlGroup]} {...question} />
                );
            }

        } catch (err) {
            return <Alert variant="danger">Error: {err.message} on loading control: {question.controlType} of questio {question.label}</Alert>
        }
    }

    validateReviewableQuestion(fieldPath) {

        var answers = this.state.worksheetAnswers;
        var selector = fieldPath.split(":");
        var errorValue = false;
        var touched = false;
        var newState = {};
        const controlGroup = stateHelpers.fetchState(answers, [...selector]);
        // if both the initial and revised are not undefined (both have values)
        // and they aren't empty
        // - and they are equal - then raise error
        const initial = controlGroup.Initial;
        const revised = controlGroup.Revised;
        if (initial !== undefined &&
            revised !== undefined &&
            initial !== "" &&
            initial === revised) {
            // error
            errorValue = true;
            touched = true;

        }
        // update the state with the errorValue
        //selector.push("error");
        let errorSelector = [...selector];
        errorSelector.push("error");
        answers = stateHelpers.updateState(answers, errorSelector, errorValue, false);
        let touchedSelector = [...selector];
        touchedSelector.push("touched");
        answers = stateHelpers.updateState(answers, touchedSelector, touched, false);
        this.setState({ worksheetAnswers: answers });
    }

    handleUserInput(event) {
        // taken straight from the React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.changeWorksheetValue(name, value);
    }

    changeWorksheetValue(name, value) {
        const selectors = name.split(':');
        const validationSelectors = name.split(':');
        var t2 = performance.now()
        var nextState = produce(this.state.worksheetAnswers, draftState => {
            stateHelpers.updateDraftState(draftState, selectors, value);
        })
        this.setState({ worksheetAnswers: nextState }, () => {
            let touchedSelector = [...validationSelectors];
            touchedSelector.pop();
            var controlGroup = stateHelpers.fetchState(nextState, [...touchedSelector]);
            if (controlGroup.touched && controlGroup.error) {
                this.validateReviewableQuestion(touchedSelector.join(":"));
            }
        });

        var t3 = performance.now()
        console.log("Call to updateDraftState " + (t3 - t2) + " milliseconds.")
    }

    changePage(moveDir) {
        var currentPage = this.state.currentPage;
        currentPage = currentPage + moveDir;
        this.setState({ currentPage: currentPage }, window.scrollTo(0, 0));
    }

    async goToPage(pageIdx) {
        if (pageIdx !== this.state.currentPage) {
            await this.saveWorksheet();
            let currentPage = pageIdx;
            this.setState({ currentPage: currentPage }, window.scrollTo(0, 0));
        }
    }

    scrollToSection(sectionIdx) {
        var myElement = document.getElementById('section-' + sectionIdx);
        var topPos = myElement.offsetTop - 60;
        document.getElementById('worksheetPageSections').scrollTop = topPos;
    }

    //async printWorksheet() {
    //    //await this.saveWorksheet();
    //    //window.open("/coding/worksheet/print/" + this.props.match.params.id, "_blank")
    //    let worksheet = this.state.worksheet;
    //    let worksheetAnswers = this.state.worksheetAnswers;
    //    var info = worksheetAnswers.information;
    //    var title = "Undefined"
    //    var modalTitle = ""
    //    if (info != undefined) {
    //        var accountName = (info.accountName ?? "").replaceAll(' ', '-')
    //        var accountId = (info.accountId ?? "")
    //        var assessmentDate = (info.ASSESSMENT_DATE ?? "NULL");
    //        var oasisType = (info.OASIS_TYPE ?? "NULL").replaceAll(' ', '-')
    //        var patientIdMrn = (info.PATIENT_ID_MRN ?? "NULL").replaceAll(' ', '-')
    //        var clinician = (info.AUTHORING_CLINICIAN ?? "NULL").replaceAll(' ', '-')
    //        title = `${accountName}_${accountId}_${assessmentDate}_${oasisType}_${patientIdMrn}_${clinician}`
    //        modalTitle = `${(info.accountName ?? "NULL")} ${accountId} ${assessmentDate} ${(info.OASIS_TYPE ?? "NULL")} ${(info.PATIENT_ID_MRN ?? "NULL")} ${(info.AUTHORING_CLINICIAN ?? "NULL")}`
    //    }

    //    var controlToPrint = <CodingWorksheetPrint worksheet={worksheet} answers={worksheetAnswers} />;

    //    this.props.showModal({
    //        open: true,
    //        documentTitle: title,
    //        title: modalTitle,
    //        controlToPrint: controlToPrint,
    //        modalClassName: "modal-xxl",
    //        closeModal: this.props.hideModal
    //    }, 'printViewModal')
    //}

    getNavigation() {
        var nav = this.state.worksheet.masterSections.map((section) => {
            return <div style={{ textOverflow: "ellipsis" }}>{section.controlGroup}: {section.name}</div>
        });
        return nav;
    }

    render() {

        const status = this.state.codingEventWorksheet.status;
        return (
            <><AssureContext>
                <WorksheetSpinner>
                <WorksheetNavigation pages={this.state.pages} currentPage={this.state.currentPage} goToPage={this.goToPage} scrollToSection={this.scrollToSection} />
                    <div className="worksheet">
                        <div className="d-flex align-items-center worksheet-header bg-light">
                            <div className="mr-auto" >{this.state.worksheet.name} Worksheet</div>
                            <div className="card-btn-group">
                                <Button variant="warning" size="sm" className={status === 0 || status === 10 ? "d-none" : null} onClick={() => this.getWorksheet()}>Refresh Worksheet</Button>
                                {
                                    //status === 0 || status === 10 ?
                                    //    <Button variant="success" size="sm" onClick={this.closeWorksheet}>Close</Button> :
                                    //    <Dropdown as={ButtonGroup} size="sm" >
                                    //        <Button variant="success" onClick={this.saveAndCloseWorksheet}>Save & Close</Button>
                                    //        <Dropdown.Toggle split variant="success" id="dropdown-split-basic" />
                                    //        <Dropdown.Menu>
                                    //            <Dropdown.Item onClick={this.saveWorksheet}>Save</Dropdown.Item>
                                    //        </Dropdown.Menu>
                                    //    </Dropdown>
                                }
                            </div>
                        </div>
                        <div id="worksheetPageSections" className="worksheet-sections">
                            {this.getCurrentPage()}
                        </div>
                    </div>
                </WorksheetSpinner>
                <ModalRoot/>
            </AssureContext></>
        )
    }

}
export default CodingWorksheetView;
//export default CodingWorksheetNew;